import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import {AppService} from '../../services/app.service';

declare const $;

@Component({
  selector: 'pm-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements AfterViewInit, OnDestroy {

  constructor(
    private app: AppService
  ) {
    app.setTitle('Cart');
    document.body.classList.add('categories-page');
  }

  ngAfterViewInit(): void {
    $('.myaccordion .brand-header').click((e) => {
      $(e.target).siblings().slideToggle();
      $(e.target).parents('.myaccordion').toggleClass('active');
    });

    // ==================================== Select DropDown Js ====================================
    $(document).ready(() => {
      $('select').niceSelect();
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('categories-page');
  }

}
